import { UIElement, UIElementOptions } from '../common/ui/uiElement';
import { UIManager } from '../common/ui/uiManager';
import { UIText } from '../common/ui/uiText';
import { Game } from './game';

export interface LevelPanelOptions extends UIElementOptions {
}

export class LevelPanel extends UIElement {
  constructor(options: LevelPanelOptions) {
    super(options);
 }

  public update() {
    super.update();
  }

  public draw() {
    let percent = Math.min(1, Game.instance.combo / Game.instance.maxCombo);
    let startAngle = 0 - (Math.PI / 2);
    let endAngle = startAngle + ((2 * Math.PI) * percent);
    let radius = (this.width/2) - 2;

    UIManager.ctx.save();

    UIManager.ctx.translate(this.getScreenX() + (this.width/2), this.getScreenY() + (this.height/2));

    UIManager.ctx.lineWidth = 5;

    UIManager.ctx.beginPath();
    UIManager.ctx.arc(0, 0, radius, 0, 2 * Math.PI);
    UIManager.ctx.strokeStyle = '#00000040';
    UIManager.ctx.stroke();

    UIManager.ctx.beginPath();
    UIManager.ctx.arc(0, 0, radius, startAngle, endAngle);
    UIManager.ctx.strokeStyle = '#00FF00';
    UIManager.ctx.stroke();

    UIManager.ctx.font = '16px arial';
    UIManager.ctx.fillStyle = '#ffffff';
    UIManager.ctx.textAlign = 'center';
    UIManager.ctx.textBaseline = 'middle';
    UIManager.ctx.fillText('L' + Game.instance.level.toString(), UIManager.isMobile ? 1 : 1, UIManager.isMobile ? 0 : 2);

    UIManager.ctx.restore();
  }
}